import type { ReactNode } from 'react';
import { Tooltip as RTooltip } from 'radix-ui';

export interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

/**
 * Supplementary hint on hover/focus. Never put essential information only in a tooltip: it is not
 * reachable on touch devices. The trigger must already have an accessible name.
 */
export function Tooltip({ content, children, side = 'top' }: TooltipProps) {
  return (
    <RTooltip.Provider delayDuration={300}>
      <RTooltip.Root>
        <RTooltip.Trigger asChild>{children}</RTooltip.Trigger>
        <RTooltip.Portal>
          <RTooltip.Content
            side={side}
            sideOffset={6}
            className="st-animate-fade z-50 max-w-xs rounded-md bg-text px-3 py-2 text-sm text-bg shadow-card"
          >
            {content}
            <RTooltip.Arrow className="fill-text" />
          </RTooltip.Content>
        </RTooltip.Portal>
      </RTooltip.Root>
    </RTooltip.Provider>
  );
}
